module.exports = __webpack_public_path__ + "static/media/Sarah.e90c9041.jpg";